// 角色类型
export const roleTypeTextMap = new Map([
  [1, '管理员'],
  [2, '游客'],
  [3, '普通']
]);
